module.exports = __webpack_public_path__ + "img/david.83d682dd.jpg";